import '@leagueplatform/ui-kit';
import { LoaderButton } from 'common/components/loader-button/loader-button.view';
import styled from 'styled-components';

export const EmployerReportsLoaderButton = styled(LoaderButton)`
  font-size: 1.2rem;
  height: 3rem;
  padding: 0 3rem;
`;
